/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@swimlane/ngx-datatable/release/components/body/scroller.component';
const styles_ScrollerComponent:any[] = ([] as any[]);
export const RenderType_ScrollerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ScrollerComponent,data:{}});
export function View_ScrollerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),i0.ɵncd((null as any),
      0),(_l()(),i0.ɵted((null as any),['\n  ']))],(null as any),(null as any));
}
export function View_ScrollerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-scroller',
      [['class','datatable-scroll']],[[4,'height','px'],[4,'width','px']],(null as any),
      (null as any),View_ScrollerComponent_0,RenderType_ScrollerComponent)),i0.ɵdid(245760,
      (null as any),0,i1.ScrollerComponent,[i0.ElementRef,i0.Renderer],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).scrollHeight;
    const currVal_1:any = i0.ɵnov(_v,1).scrollWidth;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const ScrollerComponentNgFactory:i0.ComponentFactory<i1.ScrollerComponent> = i0.ɵccf('datatable-scroller',
    i1.ScrollerComponent,View_ScrollerComponent_Host_0,{scrollbarV:'scrollbarV',scrollbarH:'scrollbarH',
        scrollHeight:'scrollHeight',scrollWidth:'scrollWidth'},{scroll:'scroll'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2Nyb2xsZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2Nyb2xsZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Njcm9sbGVyLmNvbXBvbmVudC5kLnRzLlNjcm9sbGVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Njcm9sbGVyLmNvbXBvbmVudC5kLnRzLlNjcm9sbGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAiLCI8ZGF0YXRhYmxlLXNjcm9sbGVyPjwvZGF0YXRhYmxlLXNjcm9sbGVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLGtEQUNJO01BQUEsR0FBeUI7OztvQkNEN0I7TUFBQTtNQUFBLDZFQUFBO01BQUE7TUFBQTtJQUFBOztJQUFBO0lBQUE7SUFBQSxXQUFBLG1CQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// ./aot_output/~/@swimlane/ngx-datatable/release/components/body/scroller.component.ngfactory.ts